import {useQuery} from 'react-query'
import {deleteSecurity, fetchSecurityList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import SecurityForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import ModalWithForm from '../../../components/ModalWithForm'
import {Button, Form} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import {APIResponse} from '../../../types/type'
import {SecurityBase} from './type'
import DeleteLabel from '../../../components/DeleteLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import EditLabel from '../../../components/EditLabel'
import PortalDropdown from '../../../components/PortalDropdown'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import TopBarProgress from 'react-topbar-progress-indicator'
import WithModal from '../../../components/WithModal'
import ViewAll from '../../../components/ViewAll'
import MoreInfoLabel from '../../../components/MoreInfoLabel'
import NFC from './NFC'
import clsx from 'clsx'

const securityBreadcrumbs = [
  {
    title: 'User Management',
    path: 'user-management/security',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function Security() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery<APIResponse<SecurityBase[]>>(
    'security',
    fetchSecurityList,
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    security_status: ({value}: {value: string}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    more: ({row}: {row: {original: SecurityBase}}) => {
      const orderedFields = [
        ...Object.entries(viewProps.Security.primaryFieldsToLabelMap),
        ...Object.entries(viewProps.Security.secondaryFieldsToMap),
      ]
      return (
        <WithModal
          renderModalBody={() => (
            <ViewAll data={row.original} cellModifier={cellModifier} fieldOrder={orderedFields} />
          )}
          modalTitle={
            <span>
              Details of <span className="text-primary">{row.original.security_name}</span>
            </span>
          }
          modalAttrs={{backdrop: true, size: 'lg'}}
        >
          <MoreInfoLabel />
        </WithModal>
      )
    },
    Actions: ({row}: {row: {original: SecurityBase}}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={
                <span>
                  RFID of <span className="text-primary">{row.original.security_name}</span>
                </span>
              }
              initialValues={row.original}
              Form={NFC}
              modalAttrs={{size: 'sm'}}
              onSubmit={refetch}
              triggerClassName="d-block"
            >
              <div className="px-3 py-2">
                <i
                  className={clsx(
                    'fa-brands fa-nfc-symbol fs-6',
                    row.original?.nfc_code ? 'link-info' : 'link-secondary'
                  )}
                />
                <span className="ms-2">RFID</span>
              </div>
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Security'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={SecurityForm}
              modalAttrs={{size: 'lg'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteSecurity(row.original.security_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Security</title>
      </Helmet>
      <PageTitle breadcrumbs={securityBreadcrumbs}>Security</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Security}
          fieldToLabelMap={viewProps.Security.primaryFieldsToLabelMap}
          Form={SecurityForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <>
              <ModalWithForm
                modalTitle={'Add Security'}
                triggerClassName="ms-auto"
                onSubmit={refetch}
                Form={SecurityForm}
                modalAttrs={{size: 'lg'}}
              >
                <Button size="sm">Add Security</Button>
              </ModalWithForm>
              {/* <ModalWithForm
                modalTitle={'NFC Upload'}
                onSubmit={refetch}
                Form={NFCUpload}
                initialValues={{type: 'security'}}
              >
                <Button
                  variant="light"
                  size="sm"
                  className="d-flex align-items-center gap-2 ps-4 pe-3 text-primary border border-primary rounded-3 ms-4"
                >
                  <span>NFC Upload</span>
                  <KTIcon iconName="file-up" className="fs-3 text-primary" />
                </Button>
              </ModalWithForm> */}
            </>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default Security
